<template>
	<div class="region-store-selector">
		<span v-if="label" class="region-store-selector__label">{{ label }}</span>
		<el-select v-model="selectedStoreId" :size="size" :placeholder="placeholder" :loading="loading" filterable
			@change="handleChange">
			<el-option v-if="allowAll" label="全部门店" value=""></el-option>
			<el-option v-for="store in stores" :key="store.id" :label="store.title || store.name || ('门店' + store.id)"
				:value="String(store.id)">
			</el-option>
		</el-select>
	</div>
</template>

<script>
	import {
		eltips
	} from "@/util/util";

	export default {
		name: "RegionStoreSelector",
		props: {
			value: {
				type: [String, Number],
				default: "",
			},
			label: {
				type: String,
				default: "管理门店",
			},
			size: {
				type: String,
				default: "small",
			},
			placeholder: {
				type: String,
				default: "请选择门店",
			},
			allowAll: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				loading: false,
				stores: [],
				selectedStoreId: this.value === "" || this.value == null ? "" : String(this.value),
			};
		},
		watch: {
			value(val) {
				this.selectedStoreId = val === "" || val == null ? "" : String(val);
			},
		},
		created() {
			this.loadContext();
		},
		methods: {
			loadContext() {
				this.loading = true;
				this.axios.get("/api/weishop/region/context").then((res) => {
					if (res.code == 200) {
						const context = res.data || {};
						const stores = context.stores || context.managed_stores || context.managedStores || [];
						this.stores = stores;
						sessionStorage.setItem("regionContext", JSON.stringify(context));
						this.selectDefaultStore(context);
					} else {
						eltips(res.msg, "error");
					}
					this.loading = false;
				}).catch(() => {
					this.loading = false;
				});
			},
			selectDefaultStore(context) {
				const storedStoreId = sessionStorage.getItem("currentRegionStoreId");
				const visibleStoreIds = this.stores.map((store) => String(store.id));
				let storeId = this.allowAll
					? (this.selectedStoreId || storedStoreId || "")
					: (this.selectedStoreId || storedStoreId || context.default_store_id || "");
				storeId = storeId === "" || storeId == null ? "" : String(storeId);
				if (storeId && visibleStoreIds.indexOf(storeId) === -1) {
					storeId = "";
				}
				if (!storeId && !this.allowAll && this.stores.length > 0) {
					storeId = this.stores[0].id;
				}
				this.handleChange(storeId === "" || storeId == null ? "" : String(storeId));
			},
			handleChange(storeId) {
				this.selectedStoreId = storeId === "" || storeId == null ? "" : String(storeId);
				sessionStorage.setItem("currentRegionStoreId", this.selectedStoreId);
				this.$emit("input", this.selectedStoreId);
				this.$emit("change", this.selectedStoreId);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.region-store-selector {
		display: inline-flex;
		align-items: center;
		gap: 8px;

		&__label {
			color: #606266;
			font-size: 14px;
			white-space: nowrap;
		}

		.el-select {
			width: 220px;
		}
	}
</style>
